import { RsvpStatus } from '@wix/events-types';
/** @deprecated Use getAvatarList instead if possible */
export const getAvatars = (members = [], totalGuests, isRsvp, maxAvatars, isMembersVisibleInEditor) => {
    if (isMembersVisibleInEditor && !members.length && !totalGuests) {
        return [{}, {}];
    }
    const memberAvatars = getMemberAvatars(members, isRsvp);
    return [...memberAvatars, ...getAnonymousAvatars(totalGuests, maxAvatars, memberAvatars.length)];
};
/** @deprecated Use getMemberAvatarList instead if possible */
const getMemberAvatars = (members = [], isRsvp) => {
    if (isRsvp) {
        members = members.filter(member => member.rsvpStatus === RsvpStatus.YES);
    }
    return members.map(member => ({
        name: member.nickname,
        src: member.imageUrl,
    }));
};
/** @deprecated Use getAnonymousAvatarList instead if possible */
const getAnonymousAvatars = (totalGuests, maxAvatars, memberCount) => {
    const total = getTotalAttendingGuests(totalGuests);
    const neededAvatarCount = Math.min(maxAvatars, total);
    const anonymousAvatars = [];
    while (anonymousAvatars.length < neededAvatarCount - memberCount) {
        anonymousAvatars.push({});
    }
    return anonymousAvatars;
};
/** @deprecated Use getExtraGuestsAmount instead if possible */
export const getExtraGuestsCount = (totalGuests, maxAvatars) => {
    const total = getTotalAttendingGuests(totalGuests) - maxAvatars;
    return total > 0 ? total : 0;
};
const getTotalAttendingGuests = (totalGuests) => typeof totalGuests === 'number' ? totalGuests : totalGuests.YES || 0;
export const hasGuestsGoing = (totalGuests, isRsvp) => isRsvp ? !!(totalGuests?.YES ?? 0) : !!totalGuests;
export const getAvatarList = (members = [], totalAttendingGuests, maxAvatars, isMembersVisibleInEditor) => {
    if (isMembersVisibleInEditor && !members.length && !totalAttendingGuests) {
        return [{}, {}];
    }
    const memberAvatars = getMemberAvatarList(members);
    return [...memberAvatars, ...getAnonymousAvatarList(totalAttendingGuests, maxAvatars, memberAvatars.length)];
};
export const getMemberAvatarList = (members = []) => members.map(member => ({
    name: member.nickname,
    src: member.imageUrl,
}));
export const getAnonymousAvatarList = (totalAttendingGuests, maxAvatars, memberCount) => {
    const neededAvatarCount = Math.min(maxAvatars, totalAttendingGuests);
    const anonymousAvatars = [];
    while (anonymousAvatars.length < neededAvatarCount - memberCount) {
        anonymousAvatars.push({});
    }
    return anonymousAvatars;
};
export const getExtraGuestsAmount = (totalAttendingGuests, maxAvatars) => {
    const total = totalAttendingGuests - maxAvatars;
    return total > 0 ? total : 0;
};
//# sourceMappingURL=members.js.map